(function() {
  'use strict';
  let zero = 0,
      devClass = 'dev-other',
      htmlTag = document.getElementsByTagName('html')[zero];

  if ((/Android/i).test(navigator.userAgent)) {
    devClass = 'dev-android';
  } else if ((/iPhone/i).test(navigator.userAgent) ||
             (/iPad/i).test(navigator.userAgent)) {
    devClass = 'dev-iphone';
  } 

  htmlTag.classList.add(devClass);
})();

